<div [formGroup]="form">
    <div [hidden]="!showLanguageSelector()">
        <label class="form-label" for="locales">{{'msg#editUserSettings.language' | sqMessage}}</label>
        <select [sqValidation]="form" class="form-select" formControlName="selectedLocale" id="selectedLocale" sqAutofocus>
            <option [value]="locale.name" *ngFor="let locale of locales">{{locale.display | sqMessage}}</option>
        </select>
    </div>
    <!--sq-json-editor [form]="form" [model]="model" [layout]="layout" [config]="config"></sq-json-editor-->
</div>
